__turbopack_context__.v({
  "action": "AgentEmptyState-module__1fhklG__action",
  "actionPrimary": "AgentEmptyState-module__1fhklG__actionPrimary",
  "actionSecondary": "AgentEmptyState-module__1fhklG__actionSecondary",
  "actions": "AgentEmptyState-module__1fhklG__actions",
  "compact": "AgentEmptyState-module__1fhklG__compact",
  "description": "AgentEmptyState-module__1fhklG__description",
  "desk": "AgentEmptyState-module__1fhklG__desk",
  "error": "AgentEmptyState-module__1fhklG__error",
  "face": "AgentEmptyState-module__1fhklG__face",
  "faceImg": "AgentEmptyState-module__1fhklG__faceImg",
  "facePlate": "AgentEmptyState-module__1fhklG__facePlate",
  "loadingCue": "AgentEmptyState-module__1fhklG__loadingCue",
  "offline": "AgentEmptyState-module__1fhklG__offline",
  "root": "AgentEmptyState-module__1fhklG__root",
  "statusChip": "AgentEmptyState-module__1fhklG__statusChip",
  "title": "AgentEmptyState-module__1fhklG__title",
});
